import AnalyticsEvent from './analytics-event';
import { CartProperty, createCartProperty } from '../properties/cart-property';
import { BrandProperty, createBrandProperty } from '../properties/brand-property';

export default class CartSavedForLaterEvent extends AnalyticsEvent {
  public readonly name = 'Cart Saved For Later';
  public properties: {
    cart: CartProperty;
    brand: BrandProperty;
  };

  constructor(cart: CartProperty, brand: BrandProperty) {
    super();
    this.properties = {
      cart: createCartProperty(cart),
      brand: createBrandProperty(brand),
    };
  }
}
